import { getFromLocalStorage, setInLocalStorage } from '@mobi/utils'

const LocalStorageKey = {
  OTP_METHOD_PREFERENCE: 'otp_method_preference',
  TOOLTIP: 'tooltips_track_seen',
  HAS_BEEN_REDIRECTED_TO_REVERIFY: 'has_been_redirected_to_reverify',
}

export function hasTooltipBeenSeen(contextKey: string): boolean {
  const trackedData = getTooltipTrackedData()
  if (!trackedData) return false
  return trackedData[contextKey] || false
}

export function setTooltipSeen(contextKey: string): void {
  const trackedData = getTooltipTrackedData() || {}
  trackedData[contextKey] = true
  setInLocalStorage(LocalStorageKey.TOOLTIP, JSON.stringify(trackedData))
}

export function getOtpMethodPreference(betAccountNumber: number): 'email' | 'mobile' | null {
  const preferenceMap = getOtpMethodPreferenceMap() || {}
  return preferenceMap[betAccountNumber] ?? null
}

export function setOtpMethodPreference(betAccountNumber: number, preference: 'email' | 'mobile') {
  const preferenceMap = getOtpMethodPreferenceMap() || {}
  preferenceMap[betAccountNumber] = preference
  setInLocalStorage(LocalStorageKey.OTP_METHOD_PREFERENCE, JSON.stringify(preferenceMap))
}

export function lastKnownRedirectionToReverify(betAccountNumber: number): string | null {
  const store = getFromLocalStorage(LocalStorageKey.HAS_BEEN_REDIRECTED_TO_REVERIFY)
  if (!store) return null
  try {
    const map: Record<number, string | null> = JSON.parse(store)
    return map[betAccountNumber] ?? null
  } catch {
    return null
  }
}

export function setDatestampRedirectionToReverify(betAccountNumber: number, value: string | null) {
  const store = getFromLocalStorage(LocalStorageKey.HAS_BEEN_REDIRECTED_TO_REVERIFY)
  const map: Record<number, string | null> = store ? JSON.parse(store) : {}
  map[betAccountNumber] = value
  setInLocalStorage(LocalStorageKey.HAS_BEEN_REDIRECTED_TO_REVERIFY, JSON.stringify(map))
}

// #region Local Helpers

function getTooltipTrackedData(): Record<string, boolean> | null {
  const store = getFromLocalStorage(LocalStorageKey.TOOLTIP)
  if (!store) return null

  const trackedData = JSON.parse(store)
  if (typeof trackedData !== 'object') return null

  return trackedData
}

function getOtpMethodPreferenceMap(): Record<number, 'email' | 'mobile'> | null {
  const store = getFromLocalStorage(LocalStorageKey.OTP_METHOD_PREFERENCE)
  if (!store) return null

  try {
    const trackedData = JSON.parse(store)
    if (typeof trackedData !== 'object' || trackedData === null) return null
    return trackedData
  } catch {
    return null
  }
}

// #endregion
